import { render, staticRenderFns } from "./UserPedidosAcesso.vue?vue&type=template&id=4d4af63a&scoped=true&"
import script from "./UserPedidosAcesso.vue?vue&type=script&lang=js&"
export * from "./UserPedidosAcesso.vue?vue&type=script&lang=js&"
import style0 from "./UserPedidosAcesso.vue?vue&type=style&index=0&id=4d4af63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4af63a",
  null
  
)

export default component.exports